import './styles.css';

const LineLoader = () => {
  return (
    <div className='lineLdrCont'>
        <div className="lineLdr"></div>
    </div>
  )
}

export default LineLoader;